import React, { useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { startStaffAction } from "../../../../store/redux/universeStaffReducer.js";

import {
    LockRounded,
    PersonRounded,
    ArrowForwardRounded,
    ShieldRounded,
    VisibilityRounded,
    VisibilityOffRounded,
} from "@mui/icons-material";

import "./SDDLogin.css";

export default function SDDLogin({ onAuthenticated }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // ============================================================
    // SDD LOGIN
    // ============================================================

    const submit = async (e) => {
        e.preventDefault();

        if (loading) return;

        try {
            setLoading(true);
            setError("");

            const payload = {
                username: username.trim(),
                password,
            };

            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/sdd/staff/login`,
                payload
            );

            const result = response?.data;

            if (result?.status === 200) {
                /*
                 * Expected backend response:
                 *
                 * {
                 *   status: 200,
                 *   message: "...",
                 *   staffData: {...},
                 *   authenticationType: "SDD_ACCESS"
                 * }
                 */

                dispatch(startStaffAction({ staffPayload: { staffData: result.staffData }, authenticationType: result.authenticationType, sessionToken: result.sessionToken }));
                if (!onAuthenticated) navigate("/administration/sdd-workspace");
                if (onAuthenticated) {
                    onAuthenticated(
                        result?.staffData,
                        result
                    );
                }

                return;
            }

            setError(
                result?.message ||
                "Unable to sign in."
            );
        } catch (error) {
            console.error(
                "SDD login error:",
                error?.code || "REQUEST_FAILED"
            );

            const message =
                error?.response?.data?.message ||
                error?.message ||
                "Unable to sign in. Please try again.";

            setError(message);
        } finally {
            setLoading(false);
        }
    };

    // ============================================================
    // RENDER
    // ============================================================

    return (
        <div className="sddLogin">

            {/* ======================================================
          LEFT / BRANDING AREA
      ====================================================== */}

            <section className="sddLoginStory">

                <div className="sddLoginBrand">
                    <b>U</b>

                    <span>
                        Universe Inventory
                    </span>
                </div>

                <div className="sddLoginStoryContent">

                    <small>
                        STATE LEADERSHIP PORTAL
                    </small>

                    <h1>
                        Lead development.
                        <br />
                        Build the state.
                    </h1>

                    <p>
                        A dedicated command environment for
                        State Development Directors managing
                        people, growth, accountability and
                        field execution.
                    </p>

                </div>

                <footer>
                    <ShieldRounded />

                    <span>
                        Secure staff access • North-West Nigeria
                    </span>
                </footer>

            </section>

            {/* ======================================================
          LOGIN AREA
      ====================================================== */}

            <section className="sddLoginForm">

                <form onSubmit={submit}>

                    <small className="sddLoginRole">
                        STATE DEVELOPMENT DIRECTOR
                    </small>

                    <h2>
                        Welcome back
                    </h2>

                    <p className="sddLoginDescription">
                        Sign in with your official SDD staff
                        credentials.
                    </p>

                    {/* ERROR */}

                    {error && (
                        <div
                            className="sddLoginError"
                            role="alert"
                        >
                            {error}
                        </div>
                    )}

                    {/* USERNAME */}

                    <label>
                        Staff ID or email

                        <div className="sddLoginInput">

                            <PersonRounded />

                            <input
                                type="text"
                                value={username}
                                onChange={(e) => {
                                    setUsername(
                                        e.target.value
                                    );

                                    if (error) {
                                        setError("");
                                    }
                                }}
                                placeholder="SDD-SKT-ZeroAlpha"
                                autoComplete="username"
                                disabled={loading}
                                required
                            />

                        </div>
                    </label>

                    {/* PASSWORD */}

                    <label>
                        Password

                        <div className="sddLoginInput">

                            <LockRounded />

                            <input
                                type={
                                    showPassword
                                        ? "text"
                                        : "password"
                                }
                                value={password}
                                onChange={(e) => {
                                    setPassword(
                                        e.target.value
                                    );

                                    if (error) {
                                        setError("");
                                    }
                                }}
                                placeholder="Enter your password"
                                autoComplete="current-password"
                                disabled={loading}
                                required
                            />

                            <button
                                type="button"
                                className="sddPasswordToggle"
                                onClick={() =>
                                    setShowPassword(
                                        (current) => !current
                                    )
                                }
                                disabled={loading}
                                aria-label={
                                    showPassword
                                        ? "Hide password"
                                        : "Show password"
                                }
                            >
                                {showPassword ? (
                                    <VisibilityOffRounded />
                                ) : (
                                    <VisibilityRounded />
                                )}
                            </button>

                        </div>
                    </label>

                    {/* SUBMIT */}

                    <button
                        type="submit"
                        className="sddLoginSubmit"
                        disabled={
                            loading ||
                            !username.trim() ||
                            !password
                        }
                    >
                        {loading ? (
                            <span>
                                Signing in...
                            </span>
                        ) : (
                            <>
                                <span>
                                    Enter state workspace
                                </span>

                                <ArrowForwardRounded />
                            </>
                        )}
                    </button>

                    <span className="sddLoginHelp">
                        Access is restricted to authorized
                        Universe Inventory staff.
                    </span>

                </form>

            </section>

        </div>
    );
}